const toggleArray = (array, value) => {
  const index = array.indexOf(value);

  if (index === -1) {
    array.push(value);
    return array;
  }

  array.splice(index, 1);
  return array;
};

export default toggleArray;
